<template>
  <div class>
    <el-menu
      :default-active="defaultActive"
      class="el-menu-vertical-demo"
      @select="select"
      :collapse="isCollapse"
      :unique-opened="opened"
    >
      <template v-for="item in navMenuData">
        <el-submenu
          v-if="item.children.length > 0"
          :index="item.id"
          :key="item.id"
        >
          <template slot="title">
            <span class="iconfont" :class="item.icon"></span>
            <span slot="title">{{ item.title }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="child in item.children"
              :key="child.id"
              :index="child.id"
            >
              <span class="iconfont" :class="child.icon"></span>
              <span slot="title">{{ child.title }}</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item
          v-if="item.children.length === 0"
          :index="item.id"
          :key="item.id"
        >
          <span class="iconfont" :class="item.icon"></span>
          <span slot="title">{{ item.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>
<script>
var _self;
export default {
  name: "NavMenu",
  data() {
    return {
      defaultActive: "1",
      isCollapse: false,
      navMenuData: [],
      opened: true
    };
  },
  created() {
    _self = this;
  },
  mounted() {
    //获取路由
    _self.changeStructure();
    // 页面刷新时，nav激活项显示高亮
    _self.navActiveRefresh();
  },
  methods: {
    // nav选中时切换路由
    select(index, indexPath) {
      // indexPath为数组，第一个值为一级目录id，第二个值为二级目录id
      _self.navMenuData.map(item => {
        if (item.id === indexPath[0]) {
          if (item.children.length > 0) {
            // 存在二级目录，则找二级id对应的path
            item.children.map(child => {
              if (child.id === indexPath[1]) {
                _self.$router.push(child.path);
                console.log(child.path,'child.pathchild.path');
              }
            });
          } else {
            // 不存在二级目录，则找一级id对应的path
            _self.$router.push(item.path);
          }
        }
      });
    },
    // 页面刷新或者回退路由变化时，nav激活项显示高亮
    navActiveRefresh() {
      let curRouterPath = this.$router.history.current.path;
      console.log(curRouterPath);
      //选中高亮
      for (let x in _self.navMenuData) {
        if (_self.navMenuData[x].children.length > 0) {
          for (let y in _self.navMenuData[x].children) {
            if (_self.navMenuData[x].children[y].path == curRouterPath) {
              _self.defaultActive = _self.navMenuData[x].children[y].id;
              return;
            }
          }
        } else {
          if (_self.navMenuData[x].path == curRouterPath) {
            _self.defaultActive = _self.navMenuData[x].id;
            return;
          }
        }
      }
    },
    //调整路由结构
    changeStructure() {
      var menuList = JSON.parse(window.sessionStorage.getItem("menuList"));
      let item = {
        id: "",
        icon: "",
        title: "",
        path: "",
        parentId: "",
        children: []
      };
      let parentMenuList = [];
      let childrenMenuList = [];
      //把一级菜单和二级分开
      for (let index in menuList) {
        item.id = menuList[index].id.toString();
        item.icon = menuList[index].icon;
        item.title = menuList[index].title;
        item.path = menuList[index].path;
        item.parentId = menuList[index].parentId;
        if (
          menuList[index].parentId == null ||
          menuList[index].parentId == ""
        ) {
          parentMenuList.push(JSON.parse(JSON.stringify(item)));
        } else {
          childrenMenuList.push(JSON.parse(JSON.stringify(item)));
        }
      }
      // 把二级菜单放到对应一级菜单下面
      for (let x in childrenMenuList) {
        for (let y in parentMenuList) {
          if (childrenMenuList[x].parentId == parentMenuList[y].id) {
            parentMenuList[y].children.push(childrenMenuList[x]);
          }
        }
      }
      _self.navMenuData = parentMenuList;
      console.log(_self.navMenuData,'_self.navMenuData_self.navMenuData');
    }
  }
};
</script>
<style lang="scss" scoped></style>
